'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "realty-type-other_svg__a",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "realty-type-other_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#realty-type-other_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#BFBEC8",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 56)",
    xlinkHref: "#realty-type-other_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#realty-type-other_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M39.27 26.177c0 6.112-4.954 11.067-11.066 11.067-6.112 0-11.066-4.955-11.066-11.067s4.954-11.066 11.066-11.066c6.112 0 11.066 4.954 11.066 11.066",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.926 17.036c1.143 0 2.08.887 2.16 2.01l.005.155v4.089h9.141l2.887 2.887-2.887 2.887h-9.141v12.029h-4.33V26.177H16.655l-2.886-2.886 2.886-2.887H26.76V19.2c0-1.196.97-2.165 2.166-2.165Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.496 22.846v.889h-1.97l-.001 1.997h2.934v1h-2.934v1.888h9.024l2.111-2.443-2.111-2.443-2.752.001v-.889h3.07l2.88 3.331-2.88 3.332h-10.11v-6.663h2.74Zm2.925 2.887v1h-1v-1h1Zm1.925 0v1h-1v-1h1Zm-2.444-2.887v.889H34.46v-.889h1.443Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.926 16.591a2.61 2.61 0 0 1 2.605 2.456l.004.154v21.447h3.886v1h-12.99v-1h3.884l.001-14.47h.889v14.47h3.441V19.201c0-.905-.699-1.647-1.586-1.716l-.134-.005c-.905 0-1.647.699-1.716 1.586l-.005.135v5.533h-.889V19.2a2.61 2.61 0 0 1 2.61-2.61Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M26.76 19.96v1h-3.368v-1zM20.506 19.96v.888H16.84l-2.442 2.442 2.443 2.442h12.806v.89H16.472l-3.33-3.331 3.33-3.332h4.034Zm1.962 0v1h-1v-1h1Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#BFBEC8",
    d: "m20.024 29.064-2.886 2.887 2.886 2.887h8.661v-5.774z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.911 34.393v1h-1v-1h1Zm5.218-5.773v6.662h-4.293v-.889h3.404v-4.885h-8.032l-2.442 2.443 2.442 2.442h1.741v.89H19.84l-3.33-3.332 3.33-3.331h9.29Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }))));
});
var RealtyTypeOther = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyTypeOther = RealtyTypeOther;